<ng-container *ngIf="text">
	<section class="text-align-left" *ngIf="!infoBubble">
		<ng-container [ngTemplateOutlet]="warningMessage"></ng-container>
	</section>

	<section
		class="text-align-left hover-pointer"
		*ngIf="infoBubble"
		[tooltip]="infoBubbleTemplate"
		[tooltip-position]="TooltipPosition.TOP"
		[analytic-data]="{ linkName: 'tooltip_modelSleeves' }"
	>
		<ng-container [ngTemplateOutlet]="warningMessage"></ng-container>
	</section>
	<ng-template #infoBubbleTemplate> <section [innerHTML]="infoBubble"></section> </ng-template>
</ng-container>

<ng-template #warningMessage>
	<icon class="warning-icon" type="exclamation-triangle"></icon>
	<span *ngIf="text" class="warning-message">{{ text }}</span>
</ng-template>
